import { atom } from "jotai";

export const isNavbarMinimizedAtom = atom(false);
